import { useApiClient } from '../../../hooks/useRestAPIHooks';
import { Folder, ModelUtils, TemplatingItemSummary } from '../models';
import { TemplatingItemSummaryRawData } from '../types';

const getTemplatingItemSummariesForPrefixRaw = async (
  apiClient: ReturnType<typeof useApiClient>,
  prefix: string,
) => {
  const items: TemplatingItemSummaryRawData[] = [];
  let nextPageToken: string | undefined;

  do {
    const { data } = await apiClient.request('GET /v1/ai-templates', {
      prefix,
      nextPageToken,
    });
    items.push(...(data.items ?? []));
    nextPageToken = data.links?.next || undefined;
  } while (nextPageToken);

  return items;
};

export const getTemplatingItemSummariesForPrefix = async (
  apiClient: ReturnType<typeof useApiClient>,
  prefix: string,
) => {
  const items = await getTemplatingItemSummariesForPrefixRaw(apiClient, prefix);
  return items.map(ModelUtils.templatingItemSummaryFromRawData);
};

export const getTemplatingItemsInFolder = async (
  apiClient: ReturnType<typeof useApiClient>,
  folder: Folder,
) => {
  const visited = new Set<string>();
  const queue = [folder.path];
  const templatingItems: TemplatingItemSummary[] = [];

  while (queue.length > 0) {
    const prefix = queue.shift();
    if (prefix == null || visited.has(prefix)) {
      continue;
    }
    visited.add(prefix);

    const items = await getTemplatingItemSummariesForPrefix(apiClient, prefix);
    for (const item of items) {
      if (item.type === 'folder') {
        if (!visited.has(item.path)) {
          queue.push(item.path);
        }
      } else {
        templatingItems.push(item);
      }
    }
  }

  return templatingItems;
};
